import React from 'react';

import withContextConsumer from './withContextConsumer';

import { ITPA } from '@wix/podcasts-common/dist/tpa';

const { Provider: TPAProvider, Consumer: TPAConsumer } =
  React.createContext<ITPA>(null);

const withTPA = withContextConsumer<ITPA>(TPAConsumer, (tpa) => ({
  tpa,
}));

interface IWithTPAProps {
  tpa: ITPA;
}

export { TPAProvider, TPAConsumer, withTPA, IWithTPAProps };
